import GuestStore from '../../stores/GuestStore';
import UserStore from '../../stores/UserStore';
import AuthActions from '../../actions/AuthActions';
import ConfigStore from '../../stores/ConfigStore';
import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as Endpoints } from '../../constants/PosConstants';

class Header extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            guest : false,
            selectedLocation : false,
            selectedRegister : false,
            helpDeskUrl: ''
        };

        this.onGuestStoreChange = this.onGuestStoreChange.bind(this);
        this.onUserStoreChange = this.onUserStoreChange.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    componentDidMount() {
        GuestStore.addChangeListener(this.onGuestStoreChange);
        UserStore.addChangeListener(this.onUserStoreChange);
    }

    componentWillUnmount() {
        GuestStore.removeChangeListener(this.onGuestStoreChange);
        UserStore.removeChangeListener(this.onUserStoreChange);
    }

    onGuestStoreChange() {
        var self = this;

        var route = this.props.route;
        var guest = false;

        if (route.length > 0 && route[0] === 'pos')
            guest = GuestStore.getGuestById(route[1]);

        this.setState({ guest });
    }

    onUserStoreChange() {
        var userState = UserStore.getState();
        if(userState == null) {
            console.error('User State is null');
        }

        var selectedLocation = userState.selectedLocation;
        var selectedRegister = userState.selectedRegister;

        if(!selectedRegister && this.state.guest) {
            console.warn('No register selected', userState);
        }

        AjaxPromises.POST(Endpoints.GET_HELP_DESK, UserStore.getApiData()).then(res => {
            this.setState({ helpDeskUrl: res.Data.HelpDeskUrl, selectedLocation, selectedRegister })
            });	
    }

    onMouseEnter() {
        if (this.props.route.length > 0 && this.props.route[0] === 'pos') {
            $('#header').css({ 'height' : 60 });
            $('#header .header__company').css({ 'font-size' : 24});
            $('#header .header__help-desk').css({ 'font-size' : 24, 'right': '400px'  });
            $('#header .header__guest--name').css({ 'font-size' : 24 });
            $('#header .header__guest--dob').css({ 'font-size' : 16, 'top' : 0 });
        }
    }

    onMouseLeave() {
        if (this.props.route.length > 0 && this.props.route[0] === 'pos') {
            $('#header').css({ 'height' : 40 });
            $('#header .header__company').css({ 'font-size' : 15 });
            $('#header .header__help-desk').css({ 'font-size' : 15, 'right': '250px' });
            $('#header .header__guest--name').css({ 'font-size' : 15 });
            $('#header .header__guest--dob').css({ 'font-size' : 11, 'top' : -6 });
        }
    }

    render() {
        var self = this;

        var user        = this.props.user;
        var route       = this.props.route;
        var guest       = this.state.guest;
        var location    = this.state.selectedLocation ? this.state.selectedLocation.location_name : '';
        var register    = this.state.selectedRegister ? ' - '+this.state.selectedRegister.TerminalName : '';
        var { helpDeskUrl } = this.state;
        var isTest = (window.location.href.toLowerCase().indexOf('test') > -1) || (window.location.href.toLowerCase().indexOf('localhost') > -1);
        if (route.length < 1 || route[0] !== 'pos')
            guest = false;

        if (!user)
            return null;

        var nickname = guest && guest.nickname.length > 0 ? '('+guest.nickname+')' : '';
        var dob = guest && guest.DOB.length > 0 && moment(guest.DOB).isValid() ? ' - '+moment(guest.DOB).format('DD MMM, YYYY') : '';

        return (
            <div
                id='header'
                className={'header' + (isTest ? ' header__test' : '') }
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}>

                { UserStore.getState().selectedLocation.ShowLogo &&
                    <img
                        src='/assets/LC_Horizontal2.png' />
                }

                { !UserStore.getState().selectedLocation.ShowLogo &&
                    <div className='header__company'>
                        {location} {register} ({user.FullName})
                    </div>
                }

                { guest &&
                    <div className='header__guest'>
                        <div className='header__guest--name'>
                            {guest.FullName} {nickname}
                        </div>
                        <div className='header__guest--dob'>
                            {guest.PatientType === 'Medical' &&
                                <span>{guest.MJStateIDNo}</span>
                            }
                            {dob}
                        </div>
                    </div>
                }

                {helpDeskUrl &&
                    <div className='header__help-desk'>
                        <a target='_blank' rel='noopener noreferrer' href={`//${helpDeskUrl}`} style={{color: 'inherit'}}>
                            Help Desk
                        </a>
                    </div>
                }

                { route.length === 1 && route[0] === 'guest-list' &&
                    <div
                        className='header__sign-out'
                        onClick={() => { AuthActions.logout() }}>

                        Sign Out
                    </div>
                }
                
            </div>
        );
    }
}

export default Header;


/*

                <img
                    src='/assets/LC_stacked.png' />

*/


// WEBPACK FOOTER //
// ./ui_src/app/components/header/Header.react.jsx